import type { SelectOption, TreeOption } from '@/components/organisms/Select/types';

import type { HazardousFilter } from './types';

export const countryOptions: SelectOption[] = [
  { label: 'Netherlands', value: 'netherlands' },
  { disabled: true, label: 'Germany', value: 'germany' },
  { disabled: true, label: 'China', value: 'china' },
];

export const disposerOptions: SelectOption[] = [
  { label: 'Disposer A', value: 'disposer-a' },
  { label: 'Disposer B', value: 'disposer-b' },
];

export const projectOptions: SelectOption[] = [
  { label: 'Project A', value: 'project-a' },
  { label: 'Project B', value: 'project-b' },
];

export const locationOptions: SelectOption[] = [
  { label: 'Location A', value: 'location-a' },
  { label: 'Location B', value: 'location-b' },
];

export const materialOptions: SelectOption[] = [
  { label: 'Asbestos', value: 'asbestos' },
  { label: 'Sludge', value: 'sludge' },
  { label: 'Solvent', value: 'solvent' },
  { label: 'Oil and fat', value: 'oil-and-fat' },
  { label: 'Wood', value: 'wood' },
];

export const euralOptions: TreeOption[] = [
  {
    label: '03 - Wood, paper and cardboard',
    value: '03',
    children: [{ label: '030105 - Sawdust, shavings and cuttings', value: '030105' }],
  },
  {
    label: '06 - Inorganic chemical processes',
    value: '06',
    children: [
      { label: '060101 - Sulphuric acid and sulphurous acid', value: '060101' },
      { label: '060102 - Hydrochloric acid', value: '060102' },
    ],
  },
];

export const processorOptions: SelectOption[] = [
  { label: 'Processor A', value: 'processor-a' },
  { label: 'Processor B', value: 'processor-b' },
];

export const processOptions: TreeOption[] = [
  {
    label: 'Recycling',
    value: 'recycling',
    children: [
      { label: 'Mechanical recycling', value: 'mechanical-recycling' },
      { label: 'Chemical recycling', value: 'chemical-recycling' },
    ],
  },
  {
    label: 'Recovery',
    value: 'recovery',
    children: [{ label: 'Energy recovery', value: 'energy-recovery' }],
  },
];

export const hazardousOptions: Array<{ label: string; value: HazardousFilter }> = [
  { label: 'Hazardous', value: '1' },
  { label: 'Non Hazardous', value: '0' },
];

export const radiusOptions: SelectOption[] = [
  { label: '10 km', value: 10 },
  { label: '25 km', value: 25 },
  { label: '50 km', value: 50 },
  { label: '100 km', value: 100 },
];
